import { Empty } from "antd";
import { userdeadlines } from "../../../service/UserService";
import { getUserDeadlines } from "../../../service/AdminService/userService";
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import './DeadlineTable.css';
import CommonTable from "./Table";

const PAGE_SIZE = window.innerHeight >= 1024 ? 11 : 10;

const columns = [
    {
        title: 'Deadlines',
        key: 'deadline',
        render: (record) => (
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                padding: '10px',
                borderRadius: '10px',
                border: '1px solid rgba(240, 240, 240, 1)',
            }}>
                <span style={{ color: 'rgba(70, 70, 70, 1)', fontSize: '14px', fontWeight: 400 }}>
                    {record.title}
                </span>
                <span style={{ color: 'rgba(70, 70, 70, 1)', fontSize: '14px', fontWeight: 400 }}>
                    {new Date(record.deadline).toLocaleDateString('en-GB')}
                </span>
            </div>
        ),
    },
];

const DeadlineTable = ({ userId }) => {
    const [courseList, setCourseList] = useState([]);
    const [loading, setLoading] = useState(false);
    const days = 7;

    const isAdmin = useSelector((state) => state.auth?.roles?.includes("ADMIN"));

    const fetchDeadlines = useCallback(async () => {
        setLoading(true);
        try {
            if (isAdmin) {
                const res = await getUserDeadlines(days, userId);
                setCourseList(res.data ?? []);
            } 
        } catch (err) {
            console.error("Failed to fetch deadlines:", err.message);
            setCourseList([]);
        } finally {
            setLoading(false);
        }
    }, [isAdmin, userId, days]);

    useEffect(() => {
        fetchDeadlines(0);
    }, [fetchDeadlines]);

 
    return (

            <div className="h-[260px] flex flex-col w-full rounded-xl shadow-xs">
                    <CommonTable
                        className="hide-scrollbar"
                        scroll={{ y: 180 }}
                        data={courseList}
                        columns={columns}
                        showLoader={loading}
                        serverSide={true}
                    />
            </div>
    );
};

export default DeadlineTable;